<!--
 * @Author       : lilb-b
 * @Date         : 2022-09-22 10:30:15
 * @LastEditTime: 2022-09-30 09:45:39
 * @LastEditors: GRANDSOFT\hej-n
 * @Description  : 详情
 * @FilePath: \fe_spa_joint_procurement\src\views\home\detail.vue
-->
<template>
  <div class="detail">
    <common-header />
      <div class="width-1260">
        <el-breadcrumb>
          <el-breadcrumb-item :to="{ path: '/' }"
            >平方区域联采</el-breadcrumb-item
          >
          <el-breadcrumb-item v-if="detailType == DetailStatus.bid"
            >招投标公示</el-breadcrumb-item
          >
          <el-breadcrumb-item v-if="detailType == DetailStatus.recurit"
            >招募公示</el-breadcrumb-item
          >
        </el-breadcrumb>
      </div>
    <div class="main">
      <div class="title">{{ data.title }}</div>
      <p class="publishTime">发布时间：{{ data.publishTime }}</p>
      <div v-html="data.content" class="white-back editor-content-view"></div>
    </div>
    <common-footer />
  </div>
</template>

<script>
import * as home from "@/api/home.js";
import { DetailStatus } from "../../constants/index";
import CommonFooter from "@/components/commonFooter/index.vue";
import CommonHeader from "@/components/commonHeader/index.vue";

export default {
  components: {
    CommonFooter,
    CommonHeader,
  },
  name: "detail",
  data() {
    return {
      data: {},
      detailType: this.$route.query.type,
      DetailStatus,
    };
  },
  mounted() {
    this.ligetDetailByIdst();
    window.scrollTo({ top: 0 });
  },
  methods: {
    //详情
    ligetDetailByIdst() {
      let id = this.$route.query.id;
      home.ligetDetailByIdst({ id: id }, (res) => {
        this.data = res;
      });
    },
  },
};
</script>

<style>
.new-header-component {
  background-color: transparent;
}
</style>

<style lang="scss" scoped>
.detail {
  background: linear-gradient(146deg, #fbfcfd 0%, #dee9f8 100%);
  .cursor-pointer {
    cursor: pointer;
  }
}

.weitu {
  width: 100%;
  height: auto;
}

.main {
  width: 1260px;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 6px;

  p:first-of-type {
    height: 46px;
    line-height: 46px;
    font-size: 14px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #1d2129;
  }

  .title {
    font-size: 28px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #1d2129;
    text-align: center;
    padding-top: 16px;
  }

  .white-back {
    background-color: #fff;
    padding: 20px;
    min-height: 500px;
    margin-bottom: 20px;
    font-family: "Microsoft YaHei";
    ::v-deep img {
      object-fit: contain;
      max-width: 100%;
    }
  }

  .publishTime {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #4d5968;
    margin: 18px 0;
    text-align: center;
  }
}
</style>
